/**
   * Processes diagnosis text to ensure consistent formatting.
   *
   * @param {string} text - The diagnosis text to process
   * @returns {string} The processed diagnosis text
   */
  export const formatDiagnosis = (text) => {
    return text
      .split(/\n|\s*[*•]\s+/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .map((line) => `• ${line}`)
      .join("\n");
  };